module.exports = __webpack_public_path__ + "delete.png?cfc6d241415d0a554e728cb2a2548533";